<template>
  <div>
    <div class="navbar-section fixed-top w-100 index-99" :class="color_theme">
      <!-- MOBILE TOP NAVIGATION VIEW -->
      <div
        class="container h-auto d-md-none mobile-top"
        :class="[
          nav_type === 'class' || nav_type === 'single' ? 'sub-mobile-top' : '',
        ]"
      >
        <!-- SCHOOL -->
        <div
          class="row d-flex justify-content-between align-items-center nowrap"
        >
          <!-- GEAR ICON -->
          <div class="gear-icon" v-if="nav_type === 'school'">
            <div class="icon avatar avatar-square">
              <span
                class="icon-gear"
                v-on-clickaway="onSlideOut"
                @click.self="toggleSettings"
              ></span>
            </div>
          </div>

          <!-- AVATAR -->
          <!-- PARENT AND TEACHER -->
          <div
            class="icon rounded-5 icon__user mr-2"
            :class="[
              nav_type === 'parent' ? 'brand_navy_bg' : 'brand_tonic_bg',
            ]"
            v-on-clickaway="onUserSlideOut"
            @click="toggleUserSettings"
            v-if="nav_type === 'parent' || nav_type === 'teacher'"
          >
            <img
              v-lazy="user_image"
              :alt="user_full_name | getInitials"
              v-if="user_image"
            />
            <div
              v-else
              class="avatar-text white-text font-10-5 font-weight-500"
              :class="[
                nav_type === 'parent' ? 'brand_navy_bg' : 'brand_tonic_bg',
              ]"
            >
              {{ user_full_name | getInitials }}
            </div>
            <i
              class="icon-caret-fill-down color_text"
              style="font-size: 4.5px"
            ></i>
          </div>

          <!-- STUDENT -->
          <div
            class="icon rounded-5 icon__user"
            :class="[nav_type === 'student' ? 'brand_inverse_light_bg' : '']"
            v-on-clickaway="onUserSlideOut"
            @click="toggleUserSettings"
            v-if="nav_type === 'student'"
          >
            <img v-lazy="user_image" :alt="user_full_name | getInitials" />
            <i class="icon-caret-fill-down color_text font-4-5"></i>
          </div>

          <!-- GO BACK ICON -->
          <div
            class="back-to-home"
            v-if="nav_type === 'class' || nav_type === 'single'"
          >
            <!--CLASS -->
            <router-link
              to="/school/dashboard"
              class="d-flex justify-content-start align-items-center color_text"
              v-if="nav_type === 'class'"
            >
              <span class="icon-arrow-left transparent_bg"></span>
            </router-link>

            <!-- SINGLE -->
            <div
              @click="$router.go(-1)"
              class="d-flex justify-content-start align-items-center color_text pointer"
              v-else-if="nav_type === 'single'"
            >
              <span class="icon-arrow-left transparent_bg"></span>
            </div>

            <!-- SCHOOL -->
            <router-link
              :to="'/' + nav_type + '/dashboard'"
              class="d-flex justify-content-start align-items-center color_text"
              v-else-if="nav_type === 'school'"
            >
              <span class="icon-arrow-left transparent_bg"></span>
            </router-link>

            <!-- OTHERS-->
            <template v-else>
              <template v-if="nav_type === 'teacher'">
                <router-link
                  :to="'/' + nav_type + '/feeds/' + getCurrentClass"
                  class="d-flex justify-content-start align-items-center color_text"
                >
                  <span class="icon-arrow-left transparent_bg"></span>
                </router-link>
              </template>

              <template v-else>
                <router-link
                  :to="'/' + nav_type + '/feeds/' + getSelectedChildID"
                  class="d-flex justify-content-start align-items-center color_text"
                >
                  <span class="icon-arrow-left transparent_bg"></span>
                </router-link>
              </template>
            </template>
          </div>

          <!-- BRAND LOGO -->
          <div
            class="brand-logo"
            v-if="
              nav_type === 'school' ||
              nav_type === 'parent' ||
              nav_type === 'teacher' ||
              nav_type === 'student'
            "
          >
            <router-link
              :to="'/' + nav_type + '/dashboard'"
              v-if="nav_type === 'school'"
            >
              <img v-lazy="localImg('Gradely.svg')" alt="Gradely.ng" />
            </router-link>

            <router-link :to="'/' + nav_type + '/feeds'" v-else>
              <img v-lazy="localImg('Gradely.svg')" alt="Gradely.ng" />
            </router-link>
          </div>

          <!-- CLASS TITLE -->
          <div
            class="class-title font-weight-bold"
            v-if="nav_type === 'class' || nav_type === 'single'"
          >
            {{ class_title }}
          </div>

          <!-- MORE ICONS -->
          <div class="more-icons d-flex justify-content-end align-items-center">
            <template v-if="false">
              <div
                class="icon avatar avatar-square"
                v-if="nav_type === 'school'"
              >
                <span class="icon-search"></span>
              </div>
            </template>

            <!-- ICON MESSAGE -->
            <!-- <div
              class="icon avatar avatar-square"
              v-if="nav_type==='parent' || nav_type==='teacher'"
            >
              <router-link :to="'/'+nav_type+'/message'">
                <span class="icon-message brand_navy"></span>
              </router-link>
            </div>-->

            <!-- CLASS SEARCH ICON -->
            <template v-if="false">
              <div
                class="more-icons d-flex justify-content-end align-items-center"
                v-if="nav_type === 'class'"
              >
                <div class="icon avatar avatar-square border-0 transparent_bg">
                  <span class="icon-search"></span>
                </div>
              </div>
            </template>

            <!-- SINGLE INVISIBLE ICON -->
            <div
              class="more-icons d-flex justify-content-end align-items-center invisible"
              v-if="nav_type === 'single'"
            >
              <div class="icon avatar avatar-square border-0 transparent_bg">
                <span class="icon-search"></span>
              </div>
            </div>

            <!-- NOTIFICATION ICON -->
            <div
              class="icon avatar avatar-square invisible"
              v-if="
                nav_type === 'school' ||
                nav_type === 'parent' ||
                nav_type === 'teacher' ||
                nav_type === 'student'
              "
              @click="toggleNotifications"
            >
              <span class="icon-bell"></span>
              <div class="badge-circle brand_red_bg index-9"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SETTINGS PANEL -->
    <SettingsPanel
      :user_name="user_full_name"
      :school_name="user_school_name"
      :email="user_email"
      :student_code="user_code"
      :panel_image="user_image"
      :panel_type="nav_type"
      v-if="slide_panel"
      @onClose="slide_panel = false"
    ></SettingsPanel>

    <SettingsPanel
      :user_name="user_full_name"
      :school_name="user_school_name"
      :email="user_email"
      :student_code="user_code"
      :panel_image="user_image"
      :panel_type="nav_type"
      v-if="slide_user_panel"
      @onClose="slide_user_panel = false"
    ></SettingsPanel>

    <!-- NOTIFICATION MODAL -->
    <NotificationsModal
      v-if="notification_modal"
      @closeTriggered="toggleNotifications"
    ></NotificationsModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SettingsPanel from "@/components/globalComps/SettingsPanel";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "MobileTopNav",

  props: {
    nav_type: {
      type: String,
      default: "school",
    },
    color_theme: {
      type: String,
      default: "white",
    },
  },

  filters: {
    getInitials(val) {
      if (val) {
        const names = val.split(" ");
        return names[0][0] + names[1][0];
      } else return "N/A";
    },
  },

  components: {
    SettingsPanel,
    NotificationsModal: () =>
      import(
        /* webpackChunkName: " NotificationsModal" */ "@/components/notificationComps/NotificationCover"
      ),
  },

  mixins: [clickaway],

  computed: {
    ...mapGetters(["getAuthUser", "getCurrentClass", "getSelectedChildID"]),

    user_full_name() {
      if (this.getAuthUser) return this.getAuthUser.full_name;
      else return false;
    },

    user_school_name() {
      if (this.getAuthUser) return this.getAuthUser.school_name;
      else return false;
    },

    user_email() {
      if (this.getAuthUser) return this.getAuthUser.email;
      else return false;
    },

    user_image() {
      if (this.getAuthUser) return this.getAuthUser.image;
      else return false;
    },

    user_code() {
      if (this.getAuthUser) return this.getAuthUser.code;
      else return false;
    },
  },

  watch: {
    $route: "onRouteClick",
  },

  mounted() {
    let url = this.$router.currentRoute.name;
    this.activeRoute(url);
  },

  data() {
    return {
      slide_panel: false,
      slide_user_panel: false,
      class_title: "",
      notification_modal: false,
    };
  },

  methods: {
    activeRoute(url) {
      switch (url) {
        case "ClassFeeds":
          this.class_title = "Class Feeds";
          break;

        case "ClassMembersStudents":
          this.class_title = "Class Members";
          break;

        case "ClassMembersTeachers":
          this.class_title = "Class Members";
          break;

        case "AddStudents":
          this.class_title = "Add Students";
          break;

        case "AddStudents_TP":
          this.class_title = "Add Students";
          break;

        case "StudentProfile":
          this.class_title = "Student Profile";
          break;

        case "StudentProfile_TP":
          this.class_title = "Student Profile";
          break;

        case "TeacherProfile":
          this.class_title = "Teacher Profile";
          break;

        case "ClassHomework":
          this.class_title = "Class Homework";
          break;

        case "HomeworkReview":
          this.class_title = "Homework Review";
          break;

        case "HomeworkReview_TP":
          this.class_title = "Homework Review";
          break;

        case "ClassReport":
          this.class_title = "Class Report";
          break;

        case "SchoolCalendar":
          this.class_title = "Calendar";
          break;

        case "TeacherCalendar":
          this.class_title = "Calendar";
          break;

        case "SchoolDashboardActivateStudent":
          this.class_title = "Activate Students";
          break;

        case "SchoolSettingsSubjectDetails":
          this.class_title = "Subject Details";
          break;

        default:
          this.class_title = "Gradely.ng";
      }
    },

    onRouteClick() {
      this.active_route = this.$router.currentRoute.name;
      this.activeRoute(this.active_route);
    },

    toggleSettings() {
      this.slide_panel = !this.slide_panel;
    },

    onSlideOut() {
      this.slide_panel = false;
    },

    toggleUserSettings() {
      this.slide_user_panel = !this.slide_user_panel;
    },

    toggleNotifications() {
      this.notification_modal = !this.notification_modal;
    },

    onUserSlideOut() {
      this.slide_user_panel = false;
    },
  },
};
</script>

<style>
</style>
